import React, { useState, useEffect } from "react";
import { Upload, Button, message, Modal } from "antd";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { color, image } from "../../resource";
import Text from "../Text/Text";

const ContentArea = styled.div`
  width: 100%;
  background: ${color.background1};
  border: 1px solid ${color.background2};
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 16px;
`;
const ContentAreaItem = styled.div`
  padding: 0px 8px;
  display: flex;
  align-items: center;
`;
interface Props {
  onFileUpload: any;
  value: any;
}
const UploadFilePDFCreditLimit = ({ onFileUpload, value }: Props) => {
  const [file, setFile] = useState<File | null>(null);
  const [fileURL, setFileURL] = useState<string | null>(null);

  useEffect(() => {
    return () => {
      if (fileURL) {
        URL.revokeObjectURL(fileURL);
      }
    };
  }, [fileURL]);

  const beforeUpload = (file: File) => {
    const isPDF = file.type === "application/pdf";
    if (!isPDF) {
      message.error("อัปโหลดเฉพาะไฟล์ PDF เท่านั้น");
    }
    return isPDF;
  };

  const handleRemove = () => {
    Modal.confirm({
      title: "ลบไฟล์ PDF",
      onOk: () => {
        setFile(null);
        setFileURL(null);
        if (onFileUpload) onFileUpload(null);
      },
    });
  };

  return (
    <div style={{ margin: "16px 0px 0px 0px" }}>
      <ContentArea>
        <ContentAreaItem>
          <Upload
            beforeUpload={beforeUpload}
            customRequest={({ file, onSuccess }) => {
              const url = URL.createObjectURL(file as File);
              setFile(file as File);
              setFileURL(url);
              if (onFileUpload) onFileUpload(file as File);
              if (onSuccess) onSuccess("done");
            }}
            showUploadList={false}
          >
            <Button type='primary' icon={<UploadOutlined />} disabled={!!file}>
              เลือกไฟล์
            </Button>
          </Upload>
        </ContentAreaItem>
        <ContentAreaItem style={{ flex: 1 }}>
          {value ? (
            <Text fontFamily='Sarabun' fontSize={14} color='background4'>
              {typeof value === "string" ? value : value?.name}
            </Text>
          ) : file ? (
            <a href={fileURL!} target='_blank' rel='noopener noreferrer'>
              {file.name}
            </a>
          ) : (
            <>
              <img
                src={image.pdfIcon}
                style={{ width: 24, height: 28, borderRadius: 4, marginRight: 12 }}
              />
              <Text fontFamily='Sarabun' fontSize={16} color='background4'>
                โปรดเลือกไฟล์ .PDF
              </Text>
            </>
          )}
        </ContentAreaItem>
        {file && (
          <ContentAreaItem>
            <DeleteOutlined
              style={{ color: color.error, cursor: "pointer" }}
              onClick={handleRemove}
            />
          </ContentAreaItem>
        )}
      </ContentArea>
    </div>
  );
};

export default UploadFilePDFCreditLimit;
